import moment from 'moment';
import { useMemo, useCallback } from 'react';

export interface Holiday{
    date: Date;
    description: string;
}

const addDays = (days: number, orgDate: Date): Date =>{
        var date = new Date(orgDate.valueOf());
        date.setDate(date.getDate() + days);
        return date;
}

const getEasterSunday = (InputYear:number) =>{
    var a = InputYear % 19;
    var b = Math.floor(InputYear/100);
    var c = InputYear % 100;
    var d = Math.floor(b/4);
    var e = b % 4;
    var f = Math.floor((b+8)/25);  	
    var g = Math.floor((b-f+1)/3);
    var h = (19*a+b-d-g+15) % 30;
    var i = Math.floor(c/4);
    var k = c % 4;
    var l = (32 + 2*e + 2* i - h - k) % 7;
    var m = Math.floor((a+11*h+22*l)/451);
    var n = Math.floor((h+l-7*m+114)/31);
    var p = (h+l-7*m+114) % 31;
    p++;
    var es = moment(p+"-"+n+"-"+InputYear, "DD-MM-YYYY"); 	
    return es;
}

export interface UseHolidaysReturn {
    holidays: Holiday[];
    isHoliday: (date: Date) => Holiday | undefined;
    isHolidayByDateParts: (year: number, month: number, day: number) => Holiday | undefined;
    getHolidayName: (year: number, month: number, day: number) => string;
}

export const useHolidays = (year: number): UseHolidaysReturn => {
    
  const holidays = useMemo(() => {
        var holydays = new Array<Holiday>();
        var v = getEasterSunday(year);
        const easterSunday = new Date(year, v.month(), v.date())
        holydays.push({ date: new Date(year,0,1), description: '1. nyttårsdag' });
        holydays.push({ date: new Date(year,4,1), description: '1. mai' });
        holydays.push({ date: new Date(year,4,17), description: '17. mai' });
        holydays.push({ date: new Date(year,11,24), description: 'Julaften' });
        holydays.push({ date: new Date(year,11,25), description: '1. juledag' });
        holydays.push({ date: new Date(year,11,26), description: '2. juledag' });
        holydays.push({ date: new Date(year,11,31), description: 'Nyttårsaften' });
        holydays.push({ date: addDays(-3,easterSunday), description: 'Skjærtorsdag' });
        holydays.push({ date: addDays(-2,easterSunday), description: 'Langfredag' });
        holydays.push({ date: addDays(1,easterSunday), description: '2. påskedag' });
        holydays.push({ date: addDays(39,easterSunday), description: 'Kristi himmelfartsdag' });
        holydays.push({ date: addDays(50,easterSunday), description: '2. pinsedag' });
        return holydays;
  }, [year]);

  const isHoliday = useCallback((date: Date): Holiday | undefined => {
    return holidays.find(holiday => 
      holiday.date.getDate() === date.getDate() &&
      holiday.date.getMonth() === date.getMonth() &&
      holiday.date.getFullYear() === date.getFullYear()
    );
  }, [holidays]);

  const isHolidayByDateParts = useCallback((year: number, month: number, day: number): Holiday | undefined => {
    const date = new Date(year, month - 1, day);
    return isHoliday(date);
  }, [isHoliday]);

  const getHolidayName = useCallback((year:number, month:number, day: number): string => {
    const holiday = holidays.find(holiday => 
      holiday.date.getDate() === day &&
      holiday.date.getMonth() === month - 1 &&
      holiday.date.getFullYear() === year
    );
    return holiday ? holiday.description : "";
  }, [holidays]);

  return {
    holidays,
    isHoliday,
    isHolidayByDateParts,
    getHolidayName
  };
};